import { render, staticRenderFns } from "./SubjectCreate.vue?vue&type=template&id=96a98c9a&"
import script from "./SubjectCreate.vue?vue&type=script&lang=js&"
export * from "./SubjectCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports